export const getNotificationTotalsResp = () => {
  return {
    notificationTotals: [
      {
        type: "EMAIL",
        countTotal: 1831,
        countDelivered: 1831,
        countSeen: 1447,
        rateSeen: 0.79028,
      },
      {
        countTotal: 115,
        countDelivered: 115,
        countSeen: 14,
        type: "INAPP",
        rateSeen: 0.12173913043478261,
      },
      {
        countTotal: 1039,
        countCountDelivered: 1039,
        countSeen: 0,
        type: "PUSH",
        rateSeen: 0,
      },
    ],
  };
};
